<!-- eslint-disable -->
<template>
  <CommonPages id="about-us" :class="['about-us-page']" :titlePrefix="'About Us'"
    :metaDescription="domainConfig?.['meta']?.des || 'Learn more about us and our mission'">
    <div class="about-us-full">
      <div class="about-us-full__container">
        <div class="about-us-full__content">
          <div class="about-us-full__title-container">
            <div class="about-us-full__title">About Us</div>
          </div>
          <div class="about-us-full__description">
            <h2 class="about-us-full__subtitle">About Us</h2>
            Welcome to our comprehensive automotive finance resource, your go-to destination for all
            things related to car loans and leasing. Our mission is to empower you with the tools
            and information you need to make informed decisions about your vehicle financing
            options.<br>
            <br><br>
            <h2 class="about-us-full__subtitle">Our Tools:</h2>
            <span class="about-us-full__subcontent">Auto Loan Calculator:</span> Easily estimate
            your
            monthly payments and find the best loan
            options tailored to your needs.<br>
            <span class="about-us-full__subcontent">Auto Lease Calculator:</span> Determine the most
            cost-effective leasing plans and understand
            the total cost over the lease term.<br>
            <span class="about-us-full__subcontent">Total Car Cost Calculator:</span> Get a complete
            picture of the overall expenses involved in
            owning a car, including maintenance and insurance.<br>
            <br><br>
            <h2 class="about-us-full__subtitle">Our Services:</h2>
            <span class="about-us-full__subcontent">All-Lenders Introduction:</span> Explore a wide
            range of lending options to find the perfect
            fit for your financial situation.<br>
            <span class="about-us-full__subcontent">Lenders for Bad Credits Introduction:</span> We
            provide specialized resources for those with
            less-than-perfect credit, helping you secure the best possible terms.<br>
            <br><br>
            Our team is dedicated to providing you with up-to-date information and reliable tools to
            navigate the complex world of auto financing. Whether you're buying or leasing, we're
            here to help you every step of the way.<br>
            Thank you for choosing us as your trusted automotive finance partner.
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'AboutUs',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[AboutUs] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.about-us-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	margin: 0 0 rem(88);
	background: linear-gradient(180deg, var(--theme-primary) 0%, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0) 100%);

	&__container {
		width: 100%;
		min-height: rem(800);
		position: relative;
		overflow: hidden;
	}

	&__background {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	&__bg-image {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		object-fit: cover;
	}

	&__bg-overlay {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		background: rgba(13, 12, 15, 0.7);
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		// width: rem(880);
		padding: rem(80) rem(120);
		position: relative;
		z-index: 1;
	}

	&__title-container {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #1a4048;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24); /* 100% */
	}
	&__subtitle {
		color: #1a4048;
		font-size: rem(20);
		font-style: normal;
		font-weight: 500;
		line-height: rem(20);
		margin: 0;
	}
	&__subcontent {
		color: #1a4048;
		font-size: rem(18);
		font-style: normal;
		font-weight: 500;
		line-height: rem(18);
		margin: 0;
	}

	&__description {
		color: #1a4048;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		position: relative;
		align-self: stretch;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.about-us-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.about-us-full {
		padding: rem(40) rem(16);

		&__container {
			min-height: rem(600);
		}

		&__content {
			width: 100%;
			padding: 0;
		}

		&__title {
			font-size: rem(28);
			line-height: rem(28);
		}

		&__description {
			font-size: rem(14);
			line-height: rem(24);
			text-align: left;
		}
	}
}
</style> 